import { useEffect,useState } from 'react';
import styles from '../signup.module.scss';
import stylesCandidate from '../../candidates/candidateInfo.module.scss';
import signUpImage from '../../../../assets/img/create-profile.png';
import {ReactComponent as HidePassIcon} from '../../../../assets/icons/hide_password.svg';
import {ReactComponent as ShowPassIcon} from '../../../../assets/icons/view_password.svg';
import {ReactComponent as ValidationIcon} from '../../../../assets/icons/check_gray.svg';

import { 
    validateIsAlpha,
    validateEmail,
    validateNotNull,
    validateIsChecked,
    validateMinLength,
    validateLowerCharacter,
    validateUpperCase,
    validateNumber
 } from '../../../core/validators';
import { signUp, validateEmailUsed } from '../../../api/userClient';
import { appConfig } from '../../../config/runtimeConfig';

const SignUpForm = ({
    setStepIndex,
    appContext,
    userData,
    setTalentId
}) => {

    const careersUrl = appConfig.careersLanding;

    const [passwordVisibilityFlag, setPasswordVisibilityFlag] = useState(true)
    const [formErrors, setFormErrors] = useState(false)
    const [requestFlag, setRequestFlag] = useState(false);
    const [showSuggestions, setShowSuggestions] = useState(false)

    useEffect(() => {
        const formDataFromLS = JSON.parse(localStorage.getItem('signUpInfo'));
        if( Object.keys(appContext.signUpInfo).length === 0 && formDataFromLS ) {
            setTimeout( () => {
                appContext.setSignUpInfo( formDataFromLS );
                localStorage.removeItem('signUpInfo');
            }, 1000)
        } else if (Object.keys(appContext.signUpInfo).length > 0 && !formDataFromLS) {
            appContext.setSignUpInfo({});
        }
    }, [])

    const validationFields = {
        name: [validateIsAlpha, validateNotNull],
        lastName: [validateIsAlpha, validateNotNull],
        email: [validateEmail, validateNotNull],
        terms: [validateIsChecked],
        password: [validateLowerCharacter, validateUpperCase, validateNumber, validateMinLength, validateNotNull]
    }

    const handleSubmit = event => {
        appContext.displayNotification(null, true, 'hide');
        event.preventDefault();
        setRequestFlag(true);
        const validationErrors = validateRequest();
        if (Object.keys(validationErrors).length === 0) {
            appContext.showLoading(true, 'Cargando', stylesCandidate.no_scroll);
            setShowSuggestions(false);
            validateEmailUsed(appContext.signUpInfo.email).then(({status, data}) => {
                if (status === 202 && data && data.code === 404) {
                    const request = {
                        "email": appContext.signUpInfo.email,
                        "password": appContext.signUpInfo.password,
                        "firstName": appContext.signUpInfo.name,
                        "lastName": appContext.signUpInfo.lastName,
                        "typeUser": 1000800007,
                        "passwordConfirm": appContext.signUpInfo.password,
                        "source": "Careers",
                        "roleId": [1000000001],
                        "clientId": 1000000002,
                        "statusId": 1000800004
                    };
                    if ( appContext.signUpInfo.talentId ) {
                        request.talentId = appContext.signUpInfo.talentId;
                    }
                    signUp(request).then(({status, data}) => {
                        appContext.showLoading(false, '', stylesCandidate.no_scroll);
                        if ( status === 200 && data.code === 200 && data.result ) {
                            if ( data.result.talentId ) {
                                setTalentId(data.result.talentId);
                            }
                            appContext.displayNotification("Código de verificación enviado");
                            setStepIndex(1);
                        } else {
                            appContext.displayNotification('Error al crear registro', true);
                        }
                    }).catch( error => {
                        appContext.showLoading(false, '', stylesCandidate.no_scroll);
                        if( error.code === 'ERR_NETWORK' ) {
                            appContext.displayNotification(null, true);
                        }
                        console.log(error);
                    })
                } else {
                    const emailUsed = `Dirección de correo ya registrada.${ !userData ? ' Si esta dirección es tuya, inicia sesión para continuar.' : ''}`;
                    setFormErrors({
                        email: [emailUsed]
                    })
                    appContext.showLoading(false, '', stylesCandidate.no_scroll);
                }
            }).catch( error => {
                appContext.showLoading(false, '', stylesCandidate.no_scroll);
                console.log('Error', error);
                if( error.code === 'ERR_NETWORK' ) {
                    appContext.displayNotification(null, true);
                }
            })
        } else {
            setFormErrors(validationErrors)
        }
    }

    const handleFormChange = ({target}) => {
        appContext.setSignUpInfo({ ...appContext.signUpInfo, [target.name]: target.name === "terms" ? target.checked: target.value});
    }

    const validateRequest = () => {
        const errorObject = {};
        var helper;
        // validating fields
        for(const field in validationFields) {
            for (const validator in validationFields[field]) {
                helper = validationFields[field][validator](appContext.signUpInfo[field])
                if (helper) {
                    errorObject[field] = helper
                }
            }
        }
        return errorObject
    }

    const renderSuggestions = () => appContext.isDesktopOrLaptop && showSuggestions && (
        <div className={ styles.password_validator +  " " + ((appContext.signUpInfo.password && appContext.signUpInfo.password.length > 0) ? styles.active : undefined) }>
            <div className={ styles.validator_row }>
                <p className={ styles.validator_title }>Tu contraseña debe tener:</p>
            </div>
            <div className={ styles.validator_row  +  " " + (!validateMinLength(appContext.signUpInfo.password) ? styles.validated : (((validateMinLength(appContext.signUpInfo.password) && requestFlag ) ?  styles.error : undefined )) )  }>
                <ValidationIcon />
                <p>Al menos 8 caractéres</p>
            </div> 
            <div className={ styles.validator_row +  " " + (!validateLowerCharacter(appContext.signUpInfo.password) ? styles.validated : (((validateLowerCharacter(appContext.signUpInfo.password) && requestFlag ) ?  styles.error : undefined )) ) }>
                <ValidationIcon />
                <p>Al menos una letra minúscula</p>
            </div>
            <div className={ styles.validator_row +  " " + (!validateUpperCase(appContext.signUpInfo.password) ? styles.validated : (((validateUpperCase(appContext.signUpInfo.password) && requestFlag ) ?  styles.error : undefined ))) }>
                <ValidationIcon />
                <p>Al menos una letra mayúscula</p>
            </div>
            <div className={ styles.validator_row +  " " + (!validateNumber(appContext.signUpInfo.password) ? styles.validated : (((validateNumber(appContext.signUpInfo.password) && requestFlag ) ?  styles.error : undefined ))) }>
                <ValidationIcon />
                <p>Al menos un número</p>
            </div>
            <div className={ styles.box_notch }></div>
        </div>
    )

    const renderSuggestionsMobile = () => {
        return !appContext.isDesktopOrLaptop && (
            <div className={ `${styles.password_validator} ${styles.active}` }>
                <div className={ styles.validator_row }>
                    <p className={ styles.validator_title }>Tu contraseña debe tener:</p>
                </div>
                <div className={ styles.validator_row  +  " " + (!validateMinLength(appContext.signUpInfo.password) ? styles.validated : (((validateMinLength(appContext.signUpInfo.password) && requestFlag ) ?  styles.error : undefined )) )  }>
                    <ValidationIcon />
                    <p>Al menos 8 caractéres</p>
                </div> 
                <div className={ styles.validator_row +  " " + (!validateLowerCharacter(appContext.signUpInfo.password) ? styles.validated : (((validateLowerCharacter(appContext.signUpInfo.password) && requestFlag ) ?  styles.error : undefined )) ) }>
                    <ValidationIcon />
                    <p>Al menos una letra minúscula</p>
                </div>
                <div className={ styles.validator_row +  " " + (!validateUpperCase(appContext.signUpInfo.password) ? styles.validated : (((validateUpperCase(appContext.signUpInfo.password) && requestFlag ) ?  styles.error : undefined ))) }>
                    <ValidationIcon />
                    <p>Al menos una letra mayúscula</p>
                </div>
                <div className={ styles.validator_row +  " " + (!validateNumber(appContext.signUpInfo.password) ? styles.validated : (((validateNumber(appContext.signUpInfo.password) && requestFlag ) ?  styles.error : undefined ))) }>
                    <ValidationIcon />
                    <p>Al menos un número</p>
                </div>
                <div className={ styles.box_notch }></div>
            </div>
        )
    }

    const goToPrivacyTerms = () => {
        localStorage.setItem('signUpInfo', JSON.stringify(appContext.signUpInfo));
        window.location.href = `${careersUrl}privacy`;
    }

    const renderForm = () => (
        <form className={ styles.form } onSubmit={ handleSubmit }>
            { renderRegard() }
            <div className={ styles.inputs}>
                {
                    !userData && (
                        <div className={ styles.input_field }>
                            <label htmlFor="">Nombres*</label>
                            <div>
                                <input
                                    className={ Object.keys(formErrors).includes("name") ? styles.error : undefined }
                                    name="name"
                                    value={ appContext.signUpInfo.name || '' }
                                    type="text"
                                    onClick={ () => setShowSuggestions(false) }
                                    onChange={ handleFormChange }
                                    />
                                {
                                    Object.keys(formErrors).includes("name") && (
                                        <p className={ styles.error_message }>{ formErrors.name[0] }</p>
                                    )
                                }
                            </div>
                        </div>
                    )
                }
                <div className={ styles.input_field }>
                    {
                        !userData && (
                            <div className={ styles.input_field }>
                                <label htmlFor="">Apellidos*</label>
                                <div>
                                    <input
                                        className={ Object.keys(formErrors).includes("lastName") ? styles.error : undefined }
                                        name="lastName"
                                        value={ appContext.signUpInfo.lastName || '' }
                                        type="text"
                                        onClick={ () => setShowSuggestions(false) }
                                        onChange={ handleFormChange }
                                        />
                                    {
                                        Object.keys(formErrors).includes("lastName") && (
                                            <p className={ styles.error_message }>{ formErrors.lastName[0] }</p>
                                        )
                                    }
                                </div>
                            </div>
                        )
                    }
                </div>
                <div className={ styles.input_field }>
                    <label>Correo electrónico*</label>
                    <div>
                        <input
                            className={ Object.keys(formErrors).includes("email") ? styles.error : undefined }
                            name="email"
                            value={ appContext.signUpInfo.email || '' }
                            type="text"
                            onClick={ () => setShowSuggestions(false) }
                            onChange={ handleFormChange }
                            />
                        {
                            Object.keys(formErrors).includes("email") && (
                                <p className={ styles.error_message }>{ formErrors.email[0] }</p>
                            )
                        }
                    </div>
                </div>
                <div className={ styles.input_field }>
                    <label htmlFor="">Contrase&ntilde;a*</label>
                    <div className={ styles.password_container + " " + (Object.keys(formErrors).includes("password") ? styles.error : undefined)}>
                        <input
                            type={ passwordVisibilityFlag ? "password" : "text" }
                            name="password"
                            value={ appContext.signUpInfo.password || '' }
                            onClick={ () => setShowSuggestions(true) }
                            onChange={ handleFormChange }
                            />
                        <button type='button' onClick={(() => setPasswordVisibilityFlag(!passwordVisibilityFlag))}>
                            { passwordVisibilityFlag ? <HidePassIcon /> : <ShowPassIcon /> }
                        </button>
                    </div>
                    {
                        Object.keys(formErrors).includes("password") && (
                            <p className={ styles.error_message }>{ formErrors.password[0] }</p>
                        )
                    }
                </div>
            </div>
            { renderSuggestionsMobile() }
            <div className={ styles.buttons }>
                <div className={ styles.privacy_terms}>
                    <label className={ styles.lbl_checkbox }>
                        <input
                            name="terms"
                            value={ appContext.signUpInfo.terms }
                            type="checkbox"
                            onClick={ () => setShowSuggestions(false) }
                            onChange={ handleFormChange }
                            />
                    </label>
                    <div>
                        <p>He le&iacute;do y acepto los t&eacute;rminos de la <span className={ styles.link } onClick={ () => goToPrivacyTerms() }>Pol&iacute;tica de Privacidad.</span></p>
                        {
                            Object.keys(formErrors).includes("terms") && (
                                <p className={ styles.error_message }>Por favor, lee y acepta los t&eacute;rminos y condiciones</p>
                            )
                        }
                    </div>
                </div>
                <button type="submit">Crear cuenta</button>
                <hr />
                <div className={ styles.login_links}>
                    <p>¿Ya tienes cuenta?</p>
                    <a href="/login">Inicia sesi&oacute;n aqu&iacute;</a>
                </div>
            </div>
        </form>
    )

    const renderRegard = () => userData && (
        <div className={ styles.regard }>
            <span className={ styles.regard_name }>¡Hola, {userData.firstName}!</span>
            <div className={ styles.regard_detail }>
                <span>Crea una nueva contrase&ntilde;a para tu cuenta.</span>
                <div className={ styles.regard_detail_links}>
                    <span>¿No eres t&uacute;?</span>
                    <a href="/signup">Crea tu cuenta aqu&iacute;</a>
                </div>
            </div>
        </div>
    )

    return (
        <div className={ styles.form_wrapper }>
            <div className={ styles.form_column }>
                { renderForm() }
                { renderSuggestions() }
            </div>
            <div className={ styles.image_signup }>
                <div className={ styles.text_wrapper }>
                    <div className={ styles.main_text }>
                        <p>Crea tu perfil y post&uacute;late a las grandes oportunidades laborales que tenemos para ti.</p>
                    </div>
                </div>
                { appContext.isDesktopOrLaptop && (<img src={ signUpImage } alt="" />) }
            </div>
        </div>
    )
}

export default SignUpForm;
